import React from 'react'
import HistoryImg from '../../assets/company/history_1.png'

const History = () => {
  return (
    <img style={{width: '100%'}} src={HistoryImg}></img>
  )
}

export default History